import { DESKTOP_LAYOUT_BREAKPOINT } from '../core/constants';

export function clusterDrilldownTarget(feature) {
    const props = feature && feature.properties ? feature.properties : {};
    const values = typeof props.cluster_bbox === 'string' ? props.cluster_bbox.split(',') : props.cluster_bbox;
    const parsed = Array.isArray(values) ? values.map(Number) : [];
    const bbox = parsed.length === 4 && parsed.every(Number.isFinite)
        && parsed[0] < parsed[2] && parsed[1] < parsed[3] ? parsed : null;
    const zoom = { woj: 7, powiat: 9, gmina: 12, grid: 16 }[props.cluster_level] || null;
    return { bbox, zoom };
}

export function drillDownTransactionCluster(map, feature, options = {}) {
    if (!map || !feature || typeof map.easeTo !== 'function') return false;
    const target = clusterDrilldownTarget(feature);
    const currentZoom = map.getZoom();
    const maximumZoom = typeof map.getMaxZoom === 'function' ? map.getMaxZoom() : 22;
    const mobile = typeof window !== 'undefined' && window.innerWidth < DESKTOP_LAYOUT_BREAKPOINT;
    // Reveal the area in stages instead of jumping from a city view to a street.
    const nextZoom = Math.min(maximumZoom, currentZoom + 2, Math.max(target.zoom || 0, currentZoom + 1));
    let camera;
    // On a phone, fitting bounds competes with the bottom sheet and can result
    // in tiny, inconsistent steps. Advance one level at the clicked anchor.
    if (!mobile && target.bbox && typeof map.cameraForBounds === 'function') {
        camera = map.cameraForBounds([
            [target.bbox[0], target.bbox[1]],
            [target.bbox[2], target.bbox[3]],
        ], {
            padding: options.padding == null ? 48 : options.padding,
            maxZoom: nextZoom,
            bearing: typeof map.getBearing === 'function' ? map.getBearing() : 0,
        });
    }
    // Calculate before moving: a wide density bbox must not first zoom out and
    // then jump back in. Use the clicked anchor if fitting would not advance.
    if (!camera || !Number.isFinite(camera.zoom) || camera.zoom <= currentZoom) {
        const coordinates = feature.geometry && feature.geometry.coordinates;
        if (!Array.isArray(coordinates) || coordinates.length < 2
            || !coordinates.slice(0, 2).every(Number.isFinite)) return false;
        camera = { center: coordinates, zoom: Math.min(maximumZoom, currentZoom + 1) };
        // cameraForBounds already accounts for padding; the anchor fallback
        // needs the equivalent pixel offset, without persisting map padding.
        if (options.padding && typeof options.padding === 'object') {
            const padding = options.padding;
            camera.offset = [((padding.left || 0) - (padding.right || 0)) / 2,
                ((padding.top || 0) - (padding.bottom || 0)) / 2];
        }
    }
    map.easeTo({
        ...camera,
        duration: options.duration == null ? (mobile ? 450 : 800) : options.duration,
    });
    return true;
}
